import SamplePage from './views/SamplePage.vue'

const route = [
  {
    path: '/pre-saisie-echantillon',
    name: 'saisieechantillon',
    component: SamplePage,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      role: ['A','R','I'],
      title: 'Pré-saisie échantillons',
      lang_code: "sample_pre_entry",
      customer_required: false,
      order: 1
    }
  }
]

export default route